import React from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import EventItem from '../../components/EventItem';
import BirthdateItem from '../../components/BirthdateItem';
import TodoItem from '../../components/TodoItem';

import useDiaryData from '../../hooks/useDiaryData';

const dateDisplayFormat = 'DD MMM YYYY (ddd)';

const useStyles = makeStyles(theme => ({
	root: {
		[theme.breakpoints.up('md')]: {
			paddingLeft: 30,
			paddingRight: 10,
		}
	},
	listWrapper: {
		borderTop: `1px solid #e0e0e0`,
		[theme.breakpoints.up('md')]: {
			borderLeft: `1px solid #e0e0e0`,
			borderRight: `1px solid #e0e0e0`,
		}
	},
	noFound: {
		color: '#9c9c9c',
		fontWeight: 300,
		padding: 10,
		borderBottom: `1px solid #e0e0e0`,
	},
	date: {
		position: 'sticky',
		top: theme.mixins.toolbar.minHeight,
		zIndex: 1,
		backgroundColor: 'white',
		fontWeight: 600,
		marginTop: 20,
		marginBottom: 10,
		fontSize: 20,
		[theme.breakpoints.down('sm')]: {
			display: 'none'
		}
	},
}));

function ItemListSection() {
	const classes = useStyles();
	const [diary] = useDiaryData();

	const currentDateData = diary.data.filter(e => e.date === diary.selectedDate)[0];

	const eventItems = currentDateData ? currentDateData.events : [];
	const birthdateItems = currentDateData ? currentDateData.birthdates : [];
	const todoItems = currentDateData ? currentDateData.todoes : [];

	return (
		<div className={classes.root}>
			<Typography className={classes.date}>
				{moment(diary.selectedDate).format(dateDisplayFormat)}
			</Typography>
			<div className={classes.listWrapper}>
				{!Boolean(currentDateData) && !diary.loading && (
					<Typography className={classes.noFound}>No event found</Typography>
				)}

				{birthdateItems.map((e, i) => (
					<BirthdateItem key={i} details={e} />
				))}

				{eventItems.map((e, i) => (
					<EventItem key={i} details={e} />
				))}

				{todoItems.map((e, i) => (
					<TodoItem key={i} details={e} />
				))}
			</div>
			<pre>{/*JSON.stringify(currentDateData, null, 4)*/}</pre>
		</div>
	);
}

export default ItemListSection;
